export const headerData = {
  name: "Carlos Alonso Hernando",
  title: "Hello! I am",
  desciption:
    "Hello! I'm Carlos. I began my career as an Industrial Engineer and later transitioned to becoming a Full Stack Engineer. This unique journey has given me unmatched adaptability. While I deeply love coding and exploring new technologies, I've also led diverse teams, highlighting my problem-solving strengths and effective teamwork",
  image: "https://i.ibb.co/BnrF5St/Screenshot-2023-08-16-at-17-06-43.png",
  imagebw: "https://i.ibb.co/BnrF5St/Screenshot-2023-08-16-at-17-06-43.png",
  resumePdf:
    "https://drive.google.com/file/d/1ghz0DcLpshLV6tKweAa8RmRsLwMHlCKY/view?usp=drive_link",
};
